const w = window;

/**
 * Resolve browser native request animation frame function. If one doesn't exist, return a timeout with the most common refresh rate of 60x per second
 * @return {Function(callback: FrameRequestCallback)}
 */
const requestAnimationFrame = () => {
    return w.requestAnimationFrame ||
        w.mozRequestAnimationFrame ||
     w.webkitRequestAnimationFrame ||
         w.msRequestAnimationFrame ||
    function(cb) { setTimeout(cb, 1000 / 60); };
};

export default requestAnimationFrame;
